import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "container d-flex align-center ga-1 ga-lg-2"
}
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "d-flex align-center ga-0 ga-md-1 ga-lg-2" }

import { useDisplay } from "vuetify";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";

import { useAppStore } from "@/stores";

import {
  ROUTE_ABOUT,
  ROUTE_CREATE_TOKEN,
  ROUTE_HOME,
  ROUTE_INVITE,
} from "@/utils/constants";

import ActiveAccountBtn from "@/components/Account/ActiveAccountBtn.vue";
import WalletConnectBtn from "@/components/WalletConnect/WalletConnectBtn.vue";
import ToggleDarkMode from "@/components/Header/ToggleDarkMode.vue";
import NetworkSelector from "@/components/Header/NetworkSelector.vue";
import CurrencySelector from "@/components/Header/CurrencySelector.vue";
import LanguageSelector from "@/components/Header/LanguageSelector.vue";
import AppLogo from "@/components/Common/AppLogo.vue";
import TopBarSkeleton from "@/components/Skeletons/TopBarSkeleton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const route = useRoute();
const { smAndDown } = useDisplay();
const { t } = useI18n();
const { isSdkInitialized } = storeToRefs(useAppStore());

const menuItems = [
  {
    routeName: ROUTE_HOME,
    text: t("common.tokenList"),
  },
  {
    routeName: ROUTE_CREATE_TOKEN,
    text: t("blocks.appHeader.createToken"),
  },
  {
    routeName: ROUTE_INVITE,
    text: t("blocks.appHeader.invite"),
  },
  {
    routeName: ROUTE_ABOUT,
    text: t("blocks.appHeader.about"),
  },
];

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    class: "bcl-app-header px-2 px-sm-3 px-md-4",
    location: "top",
    app: "",
    fixed: ""
  }, {
    default: _withCtx(() => [
      (!_unref(isSdkInitialized))
        ? (_openBlock(), _createBlock(TopBarSkeleton, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(AppLogo, {
                class: "logo-btn mr-md-3 mr-lg-6",
                linked: ""
              }),
              (!_unref(smAndDown))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(menuItems, ({ routeName, text }, index) => {
                    return _createVNode(_component_v_btn, {
                      key: index,
                      class: "menu-link",
                      color: _unref(route).name === routeName ? 'secondary' : 'primary',
                      to: { name: routeName },
                      exact: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(text), 1)
                      ]),
                      _: 2
                    }, 1032, ["color", "to"])
                  }), 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_v_spacer),
            _createElementVNode("div", _hoisted_3, [
              (!_unref(smAndDown))
                ? (_openBlock(), _createBlock(NetworkSelector, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(ToggleDarkMode),
              (!_unref(smAndDown))
                ? (_openBlock(), _createBlock(CurrencySelector, { key: 1 }))
                : _createCommentVNode("", true),
              _createVNode(LanguageSelector),
              _createVNode(WalletConnectBtn, {
                size: "large",
                outlined: ""
              }),
              (_unref(isSdkInitialized))
                ? (_openBlock(), _createBlock(ActiveAccountBtn, { key: 2 }))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})